document.addEventListener('DOMContentLoaded',function(){

  $(document).on('click','[faqTargetJSHANDLE]',function(e){
    e.preventDefault(); var url = window.location.href;
    if(url.includes('collections')){
      const regler = !$(this).parent('[parentNodeJSHANDLE]').hasClass('openheimer-toggle') ? $(this).parent('[parentNodeJSHANDLE]').addClass('openheimer-toggle').children('[faqSlideJSHANDLE]').slideDown() : $(this).parent('[parentNodeJSHANDLE]').removeClass('openheimer-toggle').children('[faqSlideJSHANDLE]').slideUp();
    }else{
      $(this).parent('[parentNodeJSHANDLE]').toggleClass('openheimer-toggle').children('[faqSlideJSHANDLE]').slideToggle().parent('[parentNodeJSHANDLE]').siblings('[parentNodeJSHANDLE]').removeClass('openheimer-toggle').children('[faqSlideJSHANDLE]').slideUp();
    }
  })

  
  var mainLength = document.querySelectorAll('.sBs_blow_init');
  if(mainLength.length > 1){
    $('.sBs_container').slick({slidesToShow: 1,slidesToScroll: 1,arrows: true,prevArrow:'<button type="button" class="slick-prev circle-button circle-button--lg circle-button--bordered group"><span class="sr-only">Previous</span><span class="animated-arrow animated-arrow--reverse"></span></button>', nextArrow:'<button  type="button" class="slick-next circle-button circle-button--lg circle-button--bordered group"><span class="sr-only">Next</span><span class="animated-arrow"></span></button>'});
  }

  
  let SwiperTop = new Swiper('.CC_CertifiedIconMAin.swiper', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 2000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
  });
})


    $(document).ready(function() {

    $(document).on('mouseenter','.contents li',function(e){
    e.preventDefault();
    if($(this).find('.ListWrapper').length > 0){
      $(this).find('.ListWrapper').attr('open',true).children('.mega-menu').css('opacity',1).parents('li').siblings('li').find('.ListWrapper').removeAttr('open').children('.mega-menu').css('opacity',0);
    }else{
      $(this).siblings('li').find('.ListWrapper').removeAttr('open').children('.mega-menu').css('opacity',0);
    }
  });
  
    $(document).on('mouseover',function(e){
    e.preventDefault();
    if(!$(e.target).closest('.header__icon-list').length > 0 ){
      $('.ListWrapper').attr('open',false).children('.mega-menu').css('opacity',0);
    }
  })

      
    $('.Scrolling-prevArrow').click(function() {
      $(this).addClass('scrollingButton-disabled');
      $('.Scrolling-nextArrow').removeClass('scrollingButton-disabled');
      $('.ig-filter-ac-alphabet').addClass('Customprev-Scroll')
     $('.ig-filter-ac-alphabet').removeClass('CustomNext-Scroll')
    });

    $('.Scrolling-nextArrow').click(function() {
      $(this).addClass('scrollingButton-disabled');
      $('.Scrolling-prevArrow').removeClass('scrollingButton-disabled');
      $('.ig-filter-ac-alphabet').addClass('CustomNext-Scroll');
       $('.ig-filter-ac-alphabet').removeClass('Customprev-Scroll')
    });

     $('.ig-filter-ac-alphabet li').click(function() {
       $('.ig-filter-ac-alphabet').addClass('CustomNext-Scroll');
      $('.ig-filter-ac-alphabet').addClass('Customprev-Scroll')
        $('.Scrolling-prevArrow').removeClass('scrollingButton-disabled');
    });

  
   var targetDetails = $("details.CustomItem-Benefits[is='accordion-disclosure']");
      targetDetails.attr('open', true);

      
   $(".CustomItem-Suitable .metafield-multi_line_text_field, .CustomItem-Benefits .metafield-multi_line_text_field, .CustomItem-Key .metafield-multi_line_text_field").each(function() {
      var lines = $(this).text().trim().split('\n');

      var list = $("<ul></ul>");
      lines.forEach(function(line) {
        list.append('<li>' + line.trim() + '</li>');
      });

      $(this).replaceWith(list);
    });


      
      var btn = $('#BackTopButton');
      
      $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
          btn.addClass('show');
        } else {
          btn.removeClass('show');
        }
      });
      
      btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
      });


  if(document.querySelector('.accordion__content')){
    const accordionContent = document.querySelector('.accordion__content');
    const filterStrips = accordionContent.querySelectorAll('.filter_strip');
  
    if (filterStrips.length > 5) {
      accordionContent.classList.add('customscoller');
    }
  }

  
});





